// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"f278e229","453":"7730c2b9"}[chunkId] + ".chunk.js";
};